import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import Dashboard from '../dashboard';
import MyPortfolio from '../my-portfolio';
import NewPortfolio from '../new-portfolio';
import CreditUsage from '../usage-stats';
import UsageStatsDashboard from '../usage-stats/usage-stats-dashboard';
import SearchFilter from "../search-result";
import KibanaDashboard from '../Kibana/index';
import './main.scss';
// import Correspondent from "../correspondent";
import Report from "../report";
import CreditWorthinessDashboard from "../Credit-worthiness-dashboard";
import ViewCounterParty from '../search-result/View'
import { Route, Routes ,Navigate} from "react-router-dom";
import cugCharts from '../my-portfolio/cug-portfolio/cug-charts';
import MonitoringChart from '../my-portfolio/monitoring/charts';
import EWSChart from '../my-portfolio/monitoring/ews-charts';
import EwsReport from '../my-portfolio/monitoring/ews-charts/ewsReport/ewsReport'
import BulkCaseRequest from '../bulk-case-request'
import Home from '../Home'
import withRouter from '../../withRouter';
import MisOrderData from '../mis-order-data/index'

const HomewithRouter = withRouter(Home)
const DashboardwithRouter = withRouter(Dashboard);
const MyPortfolioWithRouter = withRouter(MyPortfolio);
const NewPortfoliowithRouter = withRouter(NewPortfolio);
const CreditUsagewithRouter = withRouter(CreditUsage);
const UsageStatsDashboardwithRouter = withRouter(UsageStatsDashboard);
const BulkCaseRequestwithRouter = withRouter(BulkCaseRequest);
const ReportwithRouter = withRouter(Report);
const CreditWorthinessDashboardwithRouter = withRouter(CreditWorthinessDashboard);
const SearchFilterwithRouter = withRouter(SearchFilter);
const ViewCounterPartywithRouter = withRouter(ViewCounterParty);
const KibanaDashboardwithRouter = withRouter(KibanaDashboard);
const cugChartswithRouter = withRouter(cugCharts);
const MonitoringChartwithRouter = withRouter(MonitoringChart);
const EWSChartwithRouter = withRouter(EWSChart);
const EwsReportwithRouter = withRouter(EwsReport);
const MisOrderDatawithRouter = withRouter(MisOrderData);
class Main extends Component {
    render() {
        return (
            <main className="app-main">
                <Container fluid className="px-0">
                    <Row>
                        {/*<Correspondent/>*/}
                        <Routes>
                            <Route exact path="/dashboard" element={<DashboardwithRouter {...this.props}/>} component={Dashboard} corporateColor={this.props.corporateColor} />
                            <Route path="/dashboard/:dashboardView/:counterpartyType?" element={<DashboardwithRouter corporateColor={this.props.corporateColor} {...this.props} />} />
                            <Route path="/my-portfolio/:pageNumber/:counterpartyType?/:reportType?/:riskLevel?/:region?/:classOfCompany?/:businessSegment?/:caseStatus?/:riskTrend?/:dateRange?/:selectedCountry?/:selectedState?" element={<MyPortfolioWithRouter {...this.props}/>} component={MyPortfolio} corporateColor={this.props.corporateColor} />
                            <Route path="/cug-portfolio/:pageNumber/:searchKeyword?" element={<MyPortfolioWithRouter {...this.props}/>} component={MyPortfolio} corporateColor={this.props.corporateColor} />
                            <Route path="/new-portfolio" element={<NewPortfoliowithRouter {...this.props}/>} component={NewPortfolio} corporateColor={this.props.corporateColor} />
                            <Route path="/usage-stats/reports" element={<CreditUsagewithRouter {...this.props}/>} component={CreditUsage} corporateColor={this.props.corporateColor} />
                            <Route path="/usage-stats/dashboard" element={<UsageStatsDashboardwithRouter {...this.props}/>} component={UsageStatsDashboard} corporateColor={this.props.corporateColor} />
                            <Route path="/bulk/report/request" element={<BulkCaseRequestwithRouter {...this.props}/>} component={BulkCaseRequest} corporateColor={this.props.corporateColor} />
                            <Route path="/report/:id" component={Report} element={<ReportwithRouter {...this.props}/>} corporateColor={this.props.corporateColor} />
                            <Route path="/credit-worthiness/:counterPartyId/:counterPartyType/:id" element={<CreditWorthinessDashboardwithRouter {...this.props}/>} component={CreditWorthinessDashboard} corporateColor={this.props.corporateColor} />
                            <Route exact path="/search-result/:searchParam/:s?" element={<SearchFilterwithRouter {...this.props}/>} component={SearchFilter} corporateColor={this.props.corporateColor} />
                            <Route path="/viewcounterparty/:id" element={<ViewCounterPartywithRouter {...this.props}/>} component={ViewCounterParty} corporateColor={this.props.corporateColor} />
                            <Route path='/diy-reports' element={<KibanaDashboardwithRouter {...this.props}/>} component={KibanaDashboard} />
                            <Route path= '/cug-report/:corporateId/:counterpartyId/:cugId' element={<cugChartswithRouter {...this.props}/>} component = {cugCharts}/>
                            <Route path="/monitoring/dashboard" element={<MonitoringChartwithRouter {...this.props}/>} component ={MonitoringChart}/>
                            <Route path="/ews/ewsChart" element={<EWSChartwithRouter {...this.props}/>} component ={EWSChart}/>
                            <Route path="/ews/ewsReport" element={<EwsReportwithRouter {...this.props}/>} component ={EwsReport}/>
                            <Route path="/mis/order-data" element={<MisOrderDatawithRouter {...this.props}/>} component ={MisOrderData}/>
                            {/* <Route path="/correspondent" element={<Correspondent {...this.props}/>} component={Correspondent} /> */}
                            <Route path=""  element={<Navigate to="/home" />} />
                            <Route path="/"  element={<Navigate to="/home" />} />
                            <Route path="/home" element={<HomewithRouter {...this.props}/>} component={Home}/>
                        </Routes>
                    </Row>
                </Container>
            </main>
        );
    }
}

export default withRouter(Main);
